import React, { useState, useEffect } from 'react';
import MaterialTable from "material-table";
import EditSheduledInterviewsModal from './editSheduledInterviewsModal';
import { evaluateBasedOnResult, getSheduledInterviews, getHiringPiepelinesOfSheduledInterviews } from '../../../../services/util/sheduleInterviews';
import ReactTooltip from 'react-tooltip';
import styles from './sheduledInterviews.module.scss';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import ViewScheduledInterview from './viewScheduledInterview';
import CustomNavbar from '../../customNavbar';
import { Col, DropdownButton, Dropdown, Row, Image } from 'react-bootstrap';
import { CustomSearch } from '../../../shared/customSearch';
import { cancelSheduledInterview } from '../../../../services/util/sheduleInterviews';
import { CustomConfirmationModal } from '../../../shared/customConfirmationModal';
import { CustomConfirmationBox } from '../../../shared/customConfirmationBox';
import { cancelAndRejectInterview } from '../../../../services/util/sheduleInterviews';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import makeAnimated from 'react-select/animated';
import { CustomIconButton } from '../../../shared/customIconButton';
import { CustomStatusLabel } from '../../../shared/customStatusLabel';
import { CustomButton } from '../../../shared/customButton';
import CSSLoader from '../../../shared/cssLoader';
import Avatar from 'react-avatar';

const SheduledInterviews = (props) => {
    const animatedComponents = makeAnimated();

    const history = useHistory();

    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);

    let selected_pipeline = (params.get('pipeline') ? params.get('pipeline') : null);

    let [pipelineDropDownArray, setPipelineDropDownArray] = useState({});


    const [showModal, setShowModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    let [tableData, setTableData] = useState([]);
    let [filteredValues, setFilteredValues] = useState([]);
    let [isLoading, setLoading] = useState(false);
    let [editRowValues, setEditRowValues] = useState();
    let [showRowValues, setShowRowValues] = useState();
    let [isdeleteLoading, setDeleteLoading] = useState(false);
    let [isSubmitLoading, setSubmitLoading] = useState(false);
    let [isURLLoading, setURLLoading] = useState(false);
    const [modal, setModal] = useState({
        isOpen: false,
        value: ''
    });
    let [evaluation, setEvaluation] = useState({
        is_modal_open: false,
        candidate_data_set: {}
    })
    const [Rejectmodal, setRejectModal] = useState({
        isOpen: false,
        value: ''
    });
    let [noSearchData, setNoSearchData] = useState(false)
    let moment = require('moment-timezone');
    let viewPermission = props.permissions.actions.view_pending_interviews;
    let schedulePermission = props.permissions.actions.schedule_interviews;
    let userRole = props.role;

    const breadcrumb = [
        {
            pathaddress: '',
            pathname: 'Interview Scheduling',
            isActive: true,
            key: 1 + 'Interview Scheduling'
        },
        {
            pathaddress: ``,
            pathname: 'Scheduled Interviews',
            isActive: true,
            key: 1 + 'Scheduled Interviews'

        }
    ]

    // functions
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const editSheduledInterview = async (value) => {
        await setEditRowValues(value)
        handleShow()
    }

    const modalClose = () => setShowDetailsModal(false);
    const modalShow = () => setShowDetailsModal(true);

    const showSheduledInterview = async (value) => {
        await setShowRowValues(value)
        modalShow()
    }

    //delete request submit
    const submitSuccess = async () => {
        setDeleteLoading(true);
        let result = await cancelSheduledInterview(modal.value);
        if (result.success === true) {
            setDeleteLoading(false);
            setModal({
                isOpen: false,
                value: ''
            })
            props.GetTaskValues();
            getAllSheduledInterviewValues();
        } else {
            setDeleteLoading(false);
        }

    }

    //cancel and reject candidate
    const submitRejectAndCancel = async (values) => {
        setDeleteLoading(true);
        let result = await cancelAndRejectInterview(Rejectmodal.value, values.reason);
        if (result.success === true) {
            setDeleteLoading(false);
            setRejectModal({
                isOpen: false,
                value: ''
            })
            props.GetTaskValues();
            getAllSheduledInterviewValues();
        } else {
            setDeleteLoading(false);
        }

    }

    const onSelectCancelTab = (value) => {
        setModal({
            isOpen: true,
            value: value
        })
    }

    const onSelectCancelAndRejectTab = (value) => {
        setRejectModal({
            isOpen: true,
            value: value
        })
    }


    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }

    function searchValus(searchValue) {
        let searchVal = searchValue.toLowerCase();
        const filtered = tableData.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
        setFilteredValues(filtered);
        if (filtered.length === 0) {
            setNoSearchData(true)
        }
    }

    const confirmEvaluation = async () => {
        setSubmitLoading(true);
        let respond = await evaluateBasedOnResult(evaluation.candidate_data_set.id);
        if (respond.success === true) {
            setSubmitLoading(false);
            setEvaluation({ is_modal_open: false, candidate_data_set: {} });
            getAllSheduledInterviewValues();
        } else {
            setSubmitLoading(false);
        }
    }

    let [defaulPipelineName, setDefaultPipelineName] = useState({
        label: "All"
    })

    const getAllSheduledInterviewValues = async () => {
        setLoading(true)
        let responds = await getHiringPiepelinesOfSheduledInterviews();

        let pipeline_dropdown_array = [{
            label: 'All',
            value: 100
        }];

        if (responds.success === true) {
            for (let index = 0; index < (responds.data).length; index++) {
                let pipeline_dropdown_object = {
                    label: (responds.data)[index].pipeline_name,
                    value: (responds.data)[index].pipeline_id
                }
                pipeline_dropdown_array.push(pipeline_dropdown_object);

            }
            //setting pipleine label for selected pipeline
            if (selected_pipeline) {
                for (let index = 0; index < pipeline_dropdown_array.length; index++) {
                    if (pipeline_dropdown_array[index].value == selected_pipeline) {
                        setDefaultPipelineName(pipeline_dropdown_array[index]);

                    }
                }
            }
            setPipelineDropDownArray(pipeline_dropdown_array)
            let is_all = true;
            let respond = await getSheduledInterviews(selected_pipeline);
            if (respond.success === true) {
                let array = [];
                if (respond.data.length < 1 && (selected_pipeline != 100)) {
                    changeSelectedPipeline(100);
                }
                await (respond.data).forEach(values => {
                    let time_difference = 0;
                    let minute_difference = 0;
                    let message = null;
                    let message_alert = null;

                    let current_time_utc = moment().utc();
                    let end_time = moment(values.shedule_date).zone(values.shedule_time_zone).utc();
                    time_difference = parseInt(moment.duration(end_time.diff(current_time_utc)).asHours());
                    minute_difference = (time_difference < 1) && parseInt(moment.duration(end_time.diff(current_time_utc)).asMinutes());
                    message_alert = (time_difference <= 12 && (time_difference >= 0 && minute_difference >= 0)) ? 1 : (time_difference === 0 && minute_difference >= -59) ? 0 : (time_difference <= -1 && minute_difference < 0) && -1;
                    message = (time_difference <= 12 && (time_difference >= 0 && minute_difference >= 0)) ? (time_difference < 1 ? `${minute_difference} min` : time_difference === 1 ? `${time_difference} hour` : `${time_difference} hours`) + ' left' : (time_difference === 0 && minute_difference >= -59) ? 'Now' : (time_difference <= 0 && minute_difference < 0) && 'Overdue';

                    array.push({
                        id: values.session_id,
                        schedule_date: moment.tz(values.shedule_date, values.shedule_time_zone).format('llll'),
                        schedule_date_time_utc: values.shedule_date,
                        time_zone: values.shedule_time_zone,
                        is_scheduled: values.is_scheduled,
                        candidate_name: values.candidate_name,
                        candidate_id: values.candidate_id,
                        position: values.position,
                        pipeline_name: values.pipeline_name,
                        interview_type: values.interview_type,
                        assigned_interviewers: values.assigned_interviewers,
                        interview_location_address: values.interview_location_address,
                        candidate_email: values.candidate_email,
                        country_code: values.candidate_mobile_country_code,
                        mnumber: values.candidate_mobile_number,
                        rsvpstatus: values.overall_rsvp_status,
                        interviewstatus: values.overall_interview_status,
                        interview_status_message: message,
                        interview_status_alert: message_alert,
                        candidateRSVP: values.candidate_rsvp,
                        candidateInterviewState: values.candidate_interview_status,
                        enable_evaluate_candidate_based_on_current_feedbacks: values.enable_evaluate_candidate_based_on_current_feedbacks,
                        guidelineDescription: values.interview_guidelines_to_candidate,
                    })
                });

                setTableData(array);
                setFilteredValues(array);

                setLoading(false)
            } else {
                setLoading(false)
            }
        } else {
            setLoading(false)
        }

    }

    const changePipelineName = async (type) => {
        let respond;
        setLoading(true);
        setDefaultPipelineName(type);
        if (type.value == 100) {
            let respond = await getSheduledInterviews();
            if (respond.success === true) {
                let array = [];
                await (respond.data).forEach(values => {
                    let time_difference = 0;
                    let minute_difference = 0;
                    let message = null;
                    let message_alert = null;

                    let current_time_utc = moment().utc();
                    let end_time = moment(values.shedule_date).zone(values.shedule_time_zone).utc();
                    time_difference = parseInt(moment.duration(end_time.diff(current_time_utc)).asHours());
                    minute_difference = (time_difference < 1) && parseInt(moment.duration(end_time.diff(current_time_utc)).asMinutes());
                    message_alert = (time_difference <= 12 && (time_difference >= 0 && minute_difference >= 0)) ? 1 : (time_difference === 0 && minute_difference >= -59) ? 0 : (time_difference <= -1 && minute_difference < 0) && -1;
                    message = (time_difference <= 12 && (time_difference >= 0 && minute_difference >= 0)) ? (time_difference < 1 ? `${minute_difference} min` : time_difference === 1 ? `${time_difference} hour` : `${time_difference} hours`) + ' left' : (time_difference === 0 && minute_difference >= -59) ? 'Now' : (time_difference <= 0 && minute_difference < 0) && 'Overdue';

                    array.push({
                        id: values.session_id,
                        schedule_date: moment.tz(values.shedule_date, values.shedule_time_zone).format('llll'),
                        schedule_date_time_utc: values.shedule_date,
                        time_zone: values.shedule_time_zone,
                        is_scheduled: values.is_scheduled,
                        candidate_name: values.candidate_name,
                        candidate_id: values.candidate_id,
                        position: values.position,
                        pipeline_name: values.pipeline_name,
                        interview_type: values.interview_type,
                        assigned_interviewers: values.assigned_interviewers,
                        interview_location_address: values.interview_location_address,
                        candidate_email: values.candidate_email,
                        country_code: values.candidate_mobile_country_code,
                        mnumber: values.candidate_mobile_number,
                        rsvpstatus: values.overall_rsvp_status,
                        interviewstatus: values.overall_interview_status,
                        interview_status_message: message,
                        interview_status_alert: message_alert,
                        candidateRSVP: values.candidate_rsvp,
                        candidateInterviewState: values.candidate_interview_status,
                        enable_evaluate_candidate_based_on_current_feedbacks: values.enable_evaluate_candidate_based_on_current_feedbacks,
                        guidelineDescription: values.interview_guidelines_to_candidate,
                    })
                });

                setTableData(array);
                setFilteredValues(array);

                setLoading(false)
            } else {
                setLoading(false)
            }
        } else {
            let respond = await getSheduledInterviews(type.value);
            if (respond.success === true) {
                let array = [];
                await (respond.data).forEach(values => {
                    let time_difference = 0;
                    let minute_difference = 0;
                    let message = null;
                    let message_alert = null;

                    let current_time_utc = moment().utc();
                    let end_time = moment(values.shedule_date).zone(values.shedule_time_zone).utc();
                    time_difference = parseInt(moment.duration(end_time.diff(current_time_utc)).asHours());
                    minute_difference = (time_difference < 1) && parseInt(moment.duration(end_time.diff(current_time_utc)).asMinutes());
                    message_alert = (time_difference <= 12 && (time_difference >= 0 && minute_difference >= 0)) ? 1 : (time_difference === 0 && minute_difference >= -59) ? 0 : (time_difference <= -1 && minute_difference < 0) && -1;
                    message = (time_difference <= 12 && (time_difference >= 0 && minute_difference >= 0)) ? (time_difference < 1 ? `${minute_difference} min` : time_difference === 1 ? `${time_difference} hour` : `${time_difference} hours`) + ' left' : (time_difference === 0 && minute_difference >= -59) ? 'Now' : (time_difference <= 0 && minute_difference < 0) && 'Overdue';

                    array.push({
                        id: values.session_id,
                        schedule_date: moment.tz(values.shedule_date, values.shedule_time_zone).format('llll'),
                        schedule_date_time_utc: values.shedule_date,
                        time_zone: values.shedule_time_zone,
                        is_scheduled: values.is_scheduled,
                        candidate_name: values.candidate_name,
                        candidate_id: values.candidate_id,

                        position: values.position,
                        pipeline_name: values.pipeline_name,
                        interview_type: values.interview_type,
                        assigned_interviewers: values.assigned_interviewers,
                        interview_location_address: values.interview_location_address,
                        candidate_email: values.candidate_email,
                        country_code: values.candidate_mobile_country_code,
                        mnumber: values.candidate_mobile_number,
                        rsvpstatus: values.overall_rsvp_status,
                        interviewstatus: values.overall_interview_status,
                        interview_status_message: message,
                        interview_status_alert: message_alert,
                        candidateRSVP: values.candidate_rsvp,
                        candidateInterviewState: values.candidate_interview_status,
                        enable_evaluate_candidate_based_on_current_feedbacks: values.enable_evaluate_candidate_based_on_current_feedbacks,
                        guidelineDescription: values.interview_guidelines_to_candidate,
                    })
                });

                setTableData(array);
                setFilteredValues(array);

                setLoading(false)
            } else {
                setLoading(false)
            }
        }
    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99992C10.8334 9.53968 10.4603 9.16659 10.0001 9.16659C9.53984 9.16659 9.16675 9.53968 9.16675 9.99992C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 4.99992C10.4603 4.99992 10.8334 4.62682 10.8334 4.16659C10.8334 3.70635 10.4603 3.33325 10.0001 3.33325C9.53984 3.33325 9.16675 3.70635 9.16675 4.16659C9.16675 4.62682 9.53984 4.99992 10.0001 4.99992Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 16.6666C10.4603 16.6666 10.8334 16.2935 10.8334 15.8333C10.8334 15.373 10.4603 14.9999 10.0001 14.9999C9.53984 14.9999 9.16675 15.373 9.16675 15.8333C9.16675 16.2935 9.53984 16.6666 10.0001 16.6666Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filteredValues.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(filteredValues.length / itemsPerPage);


    const changeSelectedPipeline = async (selected_pipeline_id) => {
        history.push({
            pathname: `/app/company/scheduled-interviews`,
            search: `?pipeline=${selected_pipeline_id}`
        });
    }

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            getAllSheduledInterviewValues();
        }
        return () => { unmounted = true };
    }, []);

    useEffect(() => {
        props.toggleInterviewView(false)
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [])

    return (
        <div>
            <Helmet>
                <title>Scheduled Interviews | HireTrace</title>
            </Helmet>
            {/* Modal View Start */}
            {
                showModal === true ?
                    (<EditSheduledInterviewsModal handleClose={handleClose} showModal={showModal} editRowValues={editRowValues} getAllSheduledInterviewValues={getAllSheduledInterviewValues} />)
                    : null
            }

            {
                showDetailsModal === true ?
                    (<ViewScheduledInterview modalClose={modalClose} showDetailsModal={showDetailsModal} showRowValues={showRowValues} getAllSheduledInterviewValues={getAllSheduledInterviewValues} />)
                    : null
            }

            {/* Modal View End */}

            {/* submit cancel interview request alert confirmation start */}
            <CustomConfirmationModal
                show={modal.isOpen}
                confirmationType='danger'
                cancelIconclick={() => setModal({ isOpen: false, value: '' })}
                onSecondaryBtnClick={() => setModal({ isOpen: false, value: '' })}
                onPrimaryBtnClick={submitSuccess}
                isSecondaryBtnDisabled={isdeleteLoading === true ? true : false}
                isPrimaryBtnDisabled={isdeleteLoading === true ? true : false}
                primaryBtnBackSideIcon={isdeleteLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage="Once you cancel scheduled interview, all details relevent to current interview schedule details will be deleted."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, Cancel!"
            />
            {/* submit cancel interview request alert confirmation end */}

            {/* evaluate candidate based on current result confirmation start */}
            <CustomConfirmationModal
                show={evaluation.is_modal_open}
                confirmationType='danger'
                cancelIconclick={() => setEvaluation({ is_modal_open: false, candidate_data_set: {} })}
                onSecondaryBtnClick={() => setEvaluation({ is_modal_open: false, candidate_data_set: {} })}
                onPrimaryBtnClick={confirmEvaluation}
                isSecondaryBtnDisabled={isSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={isSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={isSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage="Once you submit evaluate candidate based on candidate result system will automatically pass/fail candidate based on current marks"
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, Submit!"
            />
            {/* evaluate candidate based on current result confirmation end */}

            {/* submit cancel and reject interview request alert confirmation start */}
            <CustomConfirmationBox
                show={Rejectmodal.isOpen}
                cancelIconclick={() => setRejectModal({ isOpen: false, value: '' })}
                onSecondaryBtnClick={() => setRejectModal({ isOpen: false, value: '' })}
                onFormSubmit={submitRejectAndCancel}
                isSecondaryBtnDisabled={isdeleteLoading === true ? true : false}
                isPrimaryBtnDisabled={isdeleteLoading === true ? true : false}
                primaryBtnBackSideIcon={isdeleteLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are trying to cancel and reject selected candidate from current stage."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, Cancel and Reject !"
                checkboxLabel="I confirm to cancel and reject candidate schedule interview"
            />
            {/* submit cancel and reject interview request alert confirmation end */}
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>
                    <div className={styles.BodyContainer}>
                        <Col>
                            <div>
                                <Row>
                                    <Col sm={3} className="mb-2">
                                        <Select
                                            options={pipelineDropDownArray}
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={defaulPipelineName}
                                            onChange={(e) => {
                                                changePipelineName(e);
                                                changeSelectedPipeline(e.value)
                                            }}
                                            styles={
                                                {
                                                    ...styles,
                                                    control: (base, state) => ({
                                                        ...base,
                                                        '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                        border: '1px solid #D0D5DD', // default border color
                                                        borderRadius: '6px',
                                                        boxShadow: 'none', // no box-shadow
                                                        height: '44px',
                                                        fontFamily: 'var(--app-primary-font-style)',
                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                        fontSize: 'var(--app-primary-font-size)',
                                                    }),
                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                        return {
                                                            ...styles,
                                                            background: isDisabled
                                                                ? null
                                                                : isSelected
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : isFocused
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : null,
                                                            color: isDisabled
                                                                ? '#ccc'
                                                                : isSelected
                                                                    ? '#24859A'
                                                                    : '#24859A',
                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                            ':active': {
                                                                ...styles[':active'],
                                                                background:
                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                            },
                                                        };
                                                    },
                                                }
                                            }
                                        />
                                    </Col>
                                    <Col sm={9} className="mb-2">
                                        <CustomSearch
                                            placeholder="Search here"
                                            handleOnChange={(e) => searchValus(e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                        <div className={styles.tableBodyContainer}>
                            {
                                ((filteredValues.length === 0) && (isLoading === false)) ?
                                    (<div>
                                        {noSearchData ?
                                            <Col>
                                                <p className={styles.infoMessage}>No records found for your search, Try a different keyword. </p>
                                            </Col>
                                            :
                                            <div>
                                                <Col>
                                                    <p className={styles.infoMessage}>No scheduled interviews. Learn more
                                                        about  <a href='https://hiretrace.io/documentation/interviews/interview-scheduling' target="_blank">Interview Scheduling</a>. </p>
                                                </Col>
                                                <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/noOffers.svg`} fluid />
                                                </Col>
                                            </div>


                                        }

                                    </div>)
                                    :
                                    (
                                        <>
                                            <div className={styles.tableContainer}>
                                                <div className={styles.tableFirstRowMainHeaderDiv}>
                                                    <Col sm={3} className={styles.tablePipelineDetailsMainHeaderRow}>
                                                        <p>Candidate Details</p>
                                                    </Col>
                                                    <Col sm={2} className={styles.tableStstusDetailsMainHeaderRow}>
                                                        <p>RVSP/Interviewers</p>
                                                    </Col>
                                                    <Col sm={2} className={styles.tablePipelineDetailsMainHeaderRow}>
                                                        <p>Schedule</p>
                                                    </Col>
                                                    <Col sm={1}>
                                                        <Row className={styles.tableInfoDetailsMainHeaderRow}>
                                                            <p>Interview Status</p>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={2} className={styles.tablePipelineDetailsMainHeaderRow}>
                                                        <p>Position/Pipeline</p>
                                                    </Col>
                                                    <Col sm={1}>
                                                        <Row className={styles.tableCandidatesInfoDetailsHeaderRow}>
                                                            <p>Sched. Interview</p>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={1}>

                                                    </Col>
                                                </div>
                                                {filteredValues?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((scheduleInterviews, i) => {
                                                    return (
                                                        <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                                            <Col sm={3}>
                                                                <Row className={styles.tableJobDetailsMainRow}>
                                                                    <Col sm={2}>
                                                                        <Avatar name={scheduleInterviews.candidate_name} size="36" round={true} />
                                                                    </Col>
                                                                    <Col sm={10}>
                                                                        <Row className={styles.tableJobDetailsRow}>
                                                                            {scheduleInterviews.candidateRSVP.rsvp === 1 ?
                                                                                <svg className={styles.checkIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                                                    <path d="M4.99992 8.27724L6.99992 10.3465L10.9999 6.20793M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </svg>
                                                                                :
                                                                                scheduleInterviews.candidateRSVP.rsvp === 0 ?
                                                                                    <svg className={styles.alertIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                                                        <path d="M7.99992 5.51816V8.27724M7.99992 11.0363H8.00659M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </svg>
                                                                                    :
                                                                                    scheduleInterviews.candidateRSVP.rsvp === -1 ?
                                                                                        <svg className={styles.xIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                                                            <path d="M9.99992 6.20793L5.99992 10.3465M5.99992 6.20793L9.99992 10.3465M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        </svg>
                                                                                        :
                                                                                        null}
                                                                            <p className={styles.tableJobDetails}>{scheduleInterviews?.candidate_name}</p>
                                                                        </Row>
                                                                        <Row className={styles.tableJobDetailsRow}>
                                                                            <p className={styles.tableSecondJobDetails}>{scheduleInterviews?.candidate_email}</p>
                                                                        </Row>
                                                                    </Col>

                                                                </Row>

                                                            </Col>
                                                            <Col sm={2}>
                                                                <Row className={styles.tableCandidatesInfoDetailsRow}>

                                                                    <p className={styles.tableJobDetails}>
                                                                        {(scheduleInterviews.assigned_interviewers).map((value) =>
                                                                            <div key={value.interviewer_id} className="renderedHeader">
                                                                                <span data-tip data-for={value.interviewer_name}>
                                                                                    {value.rsvp.state === 1 ?
                                                                                        <span>
                                                                                            <svg className={styles.checkIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                                                                <path d="M4.99992 8.27724L6.99992 10.3465L10.9999 6.20793M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            </svg>
                                                                                        </span>
                                                                                        :
                                                                                        value.rsvp.state === 0 ?
                                                                                            <span>
                                                                                                <svg className={styles.alertIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                                                                    <path d="M7.99992 5.51816V8.27724M7.99992 11.0363H8.00659M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                </svg>
                                                                                            </span>
                                                                                            :
                                                                                            value.rsvp.state === -1 ?
                                                                                                <span>
                                                                                                    <svg className={styles.xIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                                                                        <path d="M9.99992 6.20793L5.99992 10.3465M5.99992 6.20793L9.99992 10.3465M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                    </svg>
                                                                                                </span>
                                                                                                :
                                                                                                null
                                                                                    }
                                                                                    <span className={styles.candidateEmail}>{value.interviewer_name}</span>
                                                                                    <ReactTooltip id={value.interviewer_name} place="left" type="dark" effect="solid">{value.interviewer_email}</ReactTooltip>
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </p>

                                                                </Row>
                                                            </Col>
                                                            <Col sm={2}>
                                                                <div className={styles.tableJobDetailsMainTableRow}>
                                                                    <Row className={styles.tableJobDetailsRow}>
                                                                        <p className={styles.tableJobDetails}>{moment(scheduleInterviews.schedule_date).format("YYYY-MM-DD HH:mm")}</p>
                                                                    </Row>
                                                                    <Row className={styles.tableJobDetailsRow}>
                                                                        <p className={styles.tableSecondJobDetails}>({scheduleInterviews?.time_zone})</p>
                                                                    </Row>
                                                                    <Row className={styles.tableJobDetailsRow}>
                                                                        <p className={styles.tableSecondJobDetails}>{scheduleInterviews?.interview_type === 0 ? 'Online interview' : 'Physical Interview'}</p>
                                                                    </Row>
                                                                </div>

                                                            </Col>
                                                            <Col sm={1} className='d-flex align-items-center justify-content-center'>
                                                                <CustomStatusLabel type={scheduleInterviews.interviewstatus === 1 ? 'successStatus' : scheduleInterviews.interviewstatus === 0 ? 'warningStatus' : 'dangerStatus'} label={scheduleInterviews.interviewstatus === 1 ? 'Active' : scheduleInterviews.interviewstatus === 0 ? 'Pending' : scheduleInterviews.interviewstatus === -1 ? 'Overdue' : null}></CustomStatusLabel>
                                                            </Col>
                                                            <Col sm={2}>
                                                                <div className={styles.tableJobDetailsMainTableRow}>
                                                                    <Row className={styles.tableJobDetailsRow}>
                                                                        <p className={styles.tableJobDetails}>{scheduleInterviews?.position}</p>
                                                                    </Row>
                                                                    <Row className={styles.tableJobDetailsRow}>
                                                                        <p className={styles.tableSecondJobDetails}>{scheduleInterviews?.pipeline_name}</p>
                                                                    </Row>
                                                                </div>
                                                            </Col>
                                                            <Col sm={1}>
                                                                <Row className={styles.tableShareLinksRow}>
                                                                    <>
                                                                        <div className={styles.tableDatActionsLeftBtns}>
                                                                            <CustomIconButton
                                                                                type="successBtn"
                                                                                toolTipId={"viewCandidate"}
                                                                                showToolTip={true}
                                                                                toolTip={'view candidate'}
                                                                                icon={
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 20 21" fill="none">
                                                                                        <path d="M13.3333 15.5L15.8333 13M15.8333 13L18.3333 15.5M15.8333 13V18M9.99996 13.4167H6.24996C5.08699 13.4167 4.5055 13.4167 4.03234 13.5602C2.96701 13.8834 2.13333 14.717 1.81016 15.7824C1.66663 16.2555 1.66663 16.837 1.66663 18M12.0833 6.75C12.0833 8.82107 10.4044 10.5 8.33329 10.5C6.26222 10.5 4.58329 8.82107 4.58329 6.75C4.58329 4.67893 6.26222 3 8.33329 3C10.4044 3 12.0833 4.67893 12.0833 6.75Z" stroke="#344054" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </svg>
                                                                                }
                                                                                handleClick={() => viewCandidate(scheduleInterviews.candidate_id)}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <CustomIconButton
                                                                                type="successBtn"
                                                                                toolTipId={"viewscheduleInterview"}
                                                                                showToolTip={true}
                                                                                toolTip={'view schedule interview'}
                                                                                icon={
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                                        <path d="M17.5 8.83335H2.5M13.3333 2.16669V5.50002M6.66667 2.16669V5.50002M7.5 13.8334L9.16667 15.5L12.9167 11.75M6.5 18.8334H13.5C14.9001 18.8334 15.6002 18.8334 16.135 18.5609C16.6054 18.3212 16.9878 17.9387 17.2275 17.4683C17.5 16.9336 17.5 16.2335 17.5 14.8334V7.83335C17.5 6.43322 17.5 5.73316 17.2275 5.19838C16.9878 4.72797 16.6054 4.34552 16.135 4.10584C15.6002 3.83335 14.9001 3.83335 13.5 3.83335H6.5C5.09987 3.83335 4.3998 3.83335 3.86502 4.10584C3.39462 4.34552 3.01217 4.72797 2.77248 5.19838C2.5 5.73316 2.5 6.43322 2.5 7.83335V14.8334C2.5 16.2335 2.5 16.9336 2.77248 17.4683C3.01217 17.9387 3.39462 18.3212 3.86502 18.5609C4.3998 18.8334 5.09987 18.8334 6.5 18.8334Z" stroke="#344054" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </svg>
                                                                                }
                                                                                handleClick={() => showSheduledInterview(scheduleInterviews)}

                                                                            />
                                                                        </div>
                                                                    </>

                                                                </Row>
                                                            </Col>

                                                            <Col sm={1}>
                                                                <Row className={styles.tableOptionRow}>
                                                                    <div className={styles.tableOptionIconDiv}>
                                                                        <Dropdown
                                                                            alignRight={true}
                                                                        >
                                                                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu className={styles.dropdownMenu}>
                                                                                <Dropdown.Item onClick={() => viewCandidate(scheduleInterviews.candidate_id)} className={styles.dropdownText}>View Candidate</Dropdown.Item>
                                                                                <Dropdown.Item onClick={() => showSheduledInterview(scheduleInterviews)} className={styles.dropdownText}>View Interview Schedule</Dropdown.Item>
                                                                                <Dropdown.Item className={styles.dropdownText} onClick={() => editSheduledInterview(scheduleInterviews)} >Reschedule Interview</Dropdown.Item>
                                                                                {scheduleInterviews.enable_evaluate_candidate_based_on_current_feedbacks &&
                                                                                    <div>
                                                                                        <Dropdown.Item  className={styles.dropdownText} onClick={() => setEvaluation({ is_modal_open: true, candidate_data_set: scheduleInterviews })} >Pass Candidate with Current Result</Dropdown.Item>
                                                                                    </div>
                                                                                }
                                                                                <Dropdown.Divider />
                                                                                <Dropdown.Item className={styles.dropdownTextDisabled} onClick={() => onSelectCancelTab(scheduleInterviews.id)} >Cancel Interview</Dropdown.Item>
                                                                                <Dropdown.Item className={styles.dropdownTextDisabled} onClick={() => onSelectCancelAndRejectTab(scheduleInterviews.id)} >Cancel Interview / Reject Candidate</Dropdown.Item>

                                                                                <ReactTooltip id={`InterviewPermissionInfo`} place="left" type="dark" effect="solid" >
                                                                                    <div className={styles.toolTipBox}>{<p>Permission Denied.</p>}</div>
                                                                                </ReactTooltip>

                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </div>
                                                                </Row>
                                                            </Col>
                                                        </div>
                                                    );

                                                })
                                                }

                                            </div>
                                            <div>
                                                {filteredValues.length > 9 &&
                                                    <div className={styles.bottomTableDiv}>
                                                        <div className={styles.bottomTableControlsWrapper}>
                                                            <div className={styles.bottomTableControlsNextBtn}>
                                                                <CustomButton
                                                                    id="shedule_interviews_go_to_previous_page_btn"
                                                                    label="Previous"
                                                                    handleClick={handlePreviousClick}
                                                                    disabled={currentPage === 1}
                                                                    type="defaultSmallBtn"
                                                                />
                                                            </div>
                                                            <div>
                                                                <CustomButton
                                                                    id="shedule_interviews_go_to_next_page_btn"
                                                                    label="Next"
                                                                    type="defaultSmallBtn"
                                                                    handleClick={handleNextClick}
                                                                    disabled={currentPage === Math.ceil(filteredValues.length / itemsPerPage)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <span className={styles.paginationInfo}>
                                                                Page {currentPage} of {totalPages}
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </>)
                            }
                        </div>
                    </div>
                </div>)
            }

        </div>
    )
}

export default SheduledInterviews;
